module.exports = __webpack_public_path__ + "static/media/replyIcon.4a022a8a.svg";